import React from 'react';
import EndpointRoute from './EndpointRoute';

export default function RouteList({
  routes,
  routes_errors,
  onRouteChange,
  onRemoveRoute,
  edit,
}) {
  return (
    <>
      {routes.map((route, i) => {
        return (
          <EndpointRoute
            key={`route_${i}`}
            index={i}
            initialValues={route}
            duplicate={routes_errors[i]?.duplicate || false}
            onChange={onRouteChange}
            edit={edit}
            removeRoute={onRemoveRoute}
          />
        );
      })}
    </>
  );
}

